import { forwardRef, useState, useEffect } from 'react';

import LegacyView from '@gogame/ui/View';

const Iframe = forwardRef(
  (
    {
      style,
      height = 'calc(100vh - 64px)',
      width = '100%',
      id,
      name,
      src,
      withLoading = true,
      onLoad,
      classes = {},
      allowFullscreen,
      ...props
    },
    ref
  ) => {
    const [iframeLoading, setLoading] = useState(true);

    useEffect(() => {
      if (withLoading) {
        setLoading(true);
      }
    }, [src]);

    const handleLoad = () => {
      if (onLoad) {
        onLoad();
      }

      if (withLoading) {
        setLoading(false);
      }
    };

    return (
      <LegacyView
        loading={withLoading ? iframeLoading : false}
        // backdrop={true}
        style={{ height }}
        className={classes.root}
      >
        <iframe
          title={'iframe'}
          src={src}
          id={id}
          name={name}
          className={classes.iframe}
          style={{ height: height, width: width, border: 0, ...style }}
          onLoad={handleLoad}
          {...props}
          allowFullScreen
          ref={ref}
        />
      </LegacyView>
    );
  }
);
export default Iframe;
